/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Credentials represents a specific credential type
 */
export interface IdentityCredentials { 
    config?: object;
    /**
     * CreatedAt is a helper struct field for gobuffalo.pop.
     */
    created_at?: string;
    /**
     * Identifiers represents a list of unique identifiers this credential type matches.
     */
    identifiers?: Array<string>;
    /**
     * Type discriminates between different types of credentials. password CredentialsTypePassword oidc CredentialsTypeOIDC totp CredentialsTypeTOTP lookup_secret CredentialsTypeLookup webauthn CredentialsTypeWebAuthn code CredentialsTypeCodeAuth passkey CredentialsTypePasskey profile CredentialsTypeProfile link_recovery CredentialsTypeRecoveryLink  CredentialsTypeRecoveryLink is a special credential type linked to the link strategy (recovery flow).  It is not used within the credentials object itself. code_recovery CredentialsTypeRecoveryCode
     */
    type?: IdentityCredentials.TypeEnum;
    /**
     * UpdatedAt is a helper struct field for gobuffalo.pop.
     */
    updated_at?: string;
    /**
     * Version refers to the version of the credential. Useful when changing the config schema.
     */
    version?: number;
}
export namespace IdentityCredentials {
    export type TypeEnum = 'password' | 'oidc' | 'totp' | 'lookup_secret' | 'webauthn' | 'code' | 'passkey' | 'profile' | 'link_recovery' | 'code_recovery';
    export const TypeEnum = {
        Password: 'password' as TypeEnum,
        Oidc: 'oidc' as TypeEnum,
        Totp: 'totp' as TypeEnum,
        LookupSecret: 'lookup_secret' as TypeEnum,
        Webauthn: 'webauthn' as TypeEnum,
        Code: 'code' as TypeEnum,
        Passkey: 'passkey' as TypeEnum,
        Profile: 'profile' as TypeEnum,
        LinkRecovery: 'link_recovery' as TypeEnum,
        CodeRecovery: 'code_recovery' as TypeEnum
    };
}


